import CssBaseline from '@mui/material/CssBaseline';
import { viVN as coreViVN } from '@mui/material/locale';
import type { Theme } from '@mui/material/styles';
import { createTheme, ThemeProvider as MThemeProvider } from '@mui/material/styles';
// fix import sort
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import { viVN } from '@mui/x-date-pickers/locales';
import { type PropsWithChildren } from 'react';

import { customShadows } from '@/app/components/Provider/ThemeProvider/custom-shadows';
import { overrides } from '@/app/components/Provider/ThemeProvider/overrides';
import { palette } from '@/app/components/Provider/ThemeProvider/palette';
import { shadows } from '@/app/components/Provider/ThemeProvider/shadows';
import { typography } from '@/app/components/Provider/ThemeProvider/typography';

const ThemeProvider = ({ children }: PropsWithChildren) => {
  const theme = createTheme(
    {
      palette,
      typography,
      shadows,
      customShadows,
      shape: { borderRadius: 8 },
    },
    viVN,
    coreViVN
  );

  theme.components = overrides(theme) as Theme['components'];

  return (
    <AppRouterCacheProvider>
      <MThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MThemeProvider>
    </AppRouterCacheProvider>
  );
};

export default ThemeProvider;
